import { OPTION_VALUES } from "./InputValues";
import { PRODUCT_KEYS } from "./products";

export const KycPointWithAadharList = [
  {
    text: "savingsAppForm.kyc.shorter_application",
  },
  { text: "savingsAppForm.kyc.document_autofill" },
];

export const KycPointWithoutAadharList = [
  {
    text: "savingsAppForm.kyc.complete_application",
  },
  { text: "savingsAppForm.kyc.to_be_upload" },
];

export const HEALTH_DETAILS_TABS = {
  LIFE_ASSURED_HEALTH_DETAILS: "lifeAssuredHealthDetails", //additional tab in dependent journey
  HEALTH_DETAILS: "healthDetails", //proper in dependent journey
};
export const healthQuestionsSections = {
  NARCOTICS: "narcotics",
  HEALTH_CONDITIONS: "healthConditions",
  HEALTH_HISTORY: "healthHistory",
  HEALTH_HISTORY_ANNUITY: "healthHistoryAnnuity",
};

export const KYC_OPTIONS = {
  AADHAAR_KYC: "AADHAAR",
  PAN_KYC: "PAN",
  WITHOUT_KYC: "WITHOUT_KYC",
};

export const KYC_MISMATCH_TYPE = {
  DOB: "dob",
  GENDER: "gender",
};

export const CKYC_POA = {
  NREGA: "NREGA",
  AADHARCARD: "AADHARCARD",
  PASSPORT: "PASSPORT",
  DRIVINGLICENCE: "DRIVINGLICENCE",
  VOTERID: "VOTERID",
};

export const HEALTH_FOLLOWUP = {
  PREGNANT: "pregnant",
  TOBACCO: "tobacco",
  ALCOHOL: "alcohol",
  NARCOTICS: "narcotics",
  HAZARDOUS_OCCUPATION: "hazardousOccupation",
  REGULAR_MEDICINE: "regularMedicine",
  EXAMINATION: "examination",
};

//IMPORTANT : do not duplicate questions here,
// add keys in object if require any conditional rendering
/**
 * @type {HealthQuestionsObject[]}
 */
export const allHealthQuestions = [
  {
    key: "consumed_narcotics",
    showAdditionalHealthDetails: false,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    followUp: HEALTH_FOLLOWUP.NARCOTICS,
  },
  {
    key: "tobacco",
    showAdditionalHealthDetails: false,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    followUp: HEALTH_FOLLOWUP.TOBACCO,
  },
  {
    key: "alcohol",
    showAdditionalHealthDetails: false,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    followUp: HEALTH_FOLLOWUP.ALCOHOL,
  },
  {
    key: "armedForces",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    hiddenProducts: [PRODUCT_KEYS.GIFT_CITY , PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]
  },
  {
    key: "hazardousOccupation",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    followUp: HEALTH_FOLLOWUP.HAZARDOUS_OCCUPATION,
  },
  {
    key: "regularMedicine",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    visibleProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR],
    followUp: HEALTH_FOLLOWUP.REGULAR_MEDICINE,
  },
  {
    key: "regularAbsistenceMedicine",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.NARCOTICS,
    visibleProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]
  },
  {
    key: "hyperTension",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "heartAilments",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "heartSurgery",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "diabetes",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "respiratoryDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "nervousDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "gastrointestinalIssues",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "liverDisorderIssues",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "genitourinaryDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "cancerHistory",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "hivInfection",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "bloodDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "psychiatricIllness",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "boneDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
    visibleProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]
  },
  {
    key: "physicDeformity",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
    visibleProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]
  },
  {
    key: "anyOtherDisorder",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_CONDITIONS,
  },
  {
    key: "examination",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
    visibleProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR],
    followUp: HEALTH_FOLLOWUP.EXAMINATION,
  },
  {
    key: "congenitalDefects",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
  },
  {
    key: "familyHistory",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
  },
  {
    key: "medicalHistory",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
  },
  {
    key: "accidentHistory",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
  },
  {
    key: "gynecologicalIssues",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: true,
    section: healthQuestionsSections.HEALTH_HISTORY,
    hiddenProducts: [PRODUCT_KEYS.GIFT_CITY, PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]
  },
  {
    key: "pregnant",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: true,
    section: healthQuestionsSections.HEALTH_HISTORY,
    followUp: HEALTH_FOLLOWUP.PREGNANT,
  },
  {
    key: "weightGainLoss",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: false,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY,
  },
  {
    key: "diabetes_hyperTension",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "lungAilments",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "chestHeartAilments",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "physicalDeformity",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "nervousDisorder",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "cancer",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "mentalDisorder",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "kidneyAilments",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
  {
    key: "anyOtherDisorders",
    showAdditionalHealthDetails: true,
    showHealthDeclarationForm: true,
    forFemale: false,
    section: healthQuestionsSections.HEALTH_HISTORY_ANNUITY,
  },
];

export const resumeJourneyConstant = {
  RESUME: "resume",
};

export const KYCWaveoffDocs = {
  age: false,
  address: false,
  id: false,
  photograph: false,
  pan: false,
  income: false,
  payout: false,
};

export const NoteType = {
  Important: "important",
  ThankYou: "thankyou",
  Congratulations: "congratulations",
};

export const MWPA_List = [
  {
    text: "appForm.personal_details.mwpa_first",
    showBullet: true,
  },
  {
    text: "appForm.personal_details.mwpa_second",
    showBullet: true,
  },
  {
    text: "appForm.personal_details.mwpa_third",
    showBullet: true,
  },
];

export const RIDERS = {
  WOP: "WOP",
  ADBY: "ADBY",
  ACPD: "ACPD",
  BTBB: "BTBB",
};

export const RIDER_DEFAULT_CONFIG = [
  {
    sectionName: RIDERS.ACPD,
    fields: ["SA", "Premium", "ServiceTax"],
  },
  {
    sectionName: RIDERS.BTBB,
    comboKey: "BTBBCombo",
    fields: ["Percentage", "SA", "Premium", "ServiceTax"],
  },
  {
    sectionName: RIDERS.ADBY,
    comboKey: "ADBYCombo",
    fields: ["Percentage", "SA", "Premium", "ServiceTax"],
  },
];

export const SELF_EMPLOYED_LIST = [
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT,
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN,
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA,
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT,
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR,
  OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER,
];

export const NON_RIDER_OCCUPATIONS = [
  OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
  OPTION_VALUES.OCCUPATION.HOUSEWIFE,
  OPTION_VALUES.OCCUPATION.RETIRED,
  OPTION_VALUES.OCCUPATION.STUDENT,
];
